interface CheckProps {
  optionalSubComponent?: any;
}

export default function AdminPanel({ optionalSubComponent }: CheckProps) {
  return(
      <div>
        {optionalSubComponent && (
          <div className="m-3">{optionalSubComponent}</div>
        )}
      </div>
  )
}
